import {Address} from "../../schema";
import Countries from "./Countries";

/**
 * Returns address object in the form of strings line by line to use later in any representation
 * @param address {Address}
 */
export function addressToLines(address: Address): string[] {
  function buildLine(values: (string | null | undefined)[]): string {
    return values.filter(v => v !== null && v !== undefined).join(', ')
  }

  const streetLine = buildLine([address?.street1, address?.street2]).trim();
  const cityProvinceLine = buildLine([address?.city, address?.province]).trim();
  const country = address?.country ? Countries.getName(address.country) : '';
  const countryLine = buildLine([address?.postcode, country]).trim();
  return [streetLine, cityProvinceLine, countryLine].filter((x) => x.length > 0);
}
